import { HttpClient } from "./HttpClient";
import * as endPoints from "constants/endPoints"

export class RegisterRequestService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async RegisterRequestItem(bodyData) {
        const { data } = await this.http.postBody(endPoints.REGISTER_REQUEST, bodyData)
        return data
    }
}

export class CPlanesService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getCPlanesItems(id_familia) {
        const { data } = await this.http.get(`${endPoints.GET_CPLANES}?fi_familia=${id_familia}`)
        return data
    }
}